/* eslint-disable */
export const SUGGESTIONS = [
	'declutter your desk',
	'learn one sentence from a foreign language you don\'t know',
	'do something important you\'ve been putting away for a long time',
	'find a thing that can be fixed and fix it',
	'set a goal for next week and one task that will help you meet it',
	'learn something new that can potentially increase your salary',
	'negotiate a better price / conditions (even online)',
	'schedule your next day in detail',
	'do something creative',
	'cook something new',
	'paint something',
	'discover a new place',
	'take a picture',
	'take a free online course',
	'unsubscribe from at least 1 toxic profile',
	'watch the news in a foreign language you don\'t know',
	'do a random act of kindness',
	'brush your teeth with your other hand',
	'schedule for tomorrow the 2 most important tasks to be completed',
	'not use any electronics for two hours before bedtime',
	'talk about yourself in the third person for at least half an hour',
	'declutter your smartphone apps',
	'find your three activities that you did last month that had the biggest impact on your life',
	'donate to charity',
	'tell someone what they mean to you',
	'ask a stranger anything',
	'be alone for one hour only with yourself, paper and a pen',
	'say yes to something you wouldn\'t normally do',
	'call an old friend',
	'find a new spot in your city',
	'sleep an hour longer than usual',
	'play a chess',
	'write down 5 to 10 things that you’re grateful for',
	'go outside to watch sunset',
	'do something social',
	'track a time for all activities all day and review it later',
	'play a favorite song you didn\'t hear for a long time',
	'take the first step towards something big',
	'write a public opinion on something',
	'use a different means of transport than usual to get to work / school',
	'think deeper about your upcoming goals',
	'walk around your home and identify a thing you’ve been tolerating and fix it',
	'try a new exercise for at least 10 minutes',
	'go to bed an hour earlier',
	'go out with a friend you haven\'t seen for a long time',
	'leave a nice message on a piece of paper somewhere outside',
]
